import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { AppProviders } from '@/app/providers/AppProviders';
import { router } from '@/app/router/AppRouter';
import { PageLoader } from '@/components/feedback/PageLoader';

export function App() {
	return (
		<AppProviders>
			<Suspense fallback={<PageLoader fullScreen />}>
				<RouterProvider router={router} />
			</Suspense>
		</AppProviders>
	);
}
